import ModalStack from '@/components/Custom/ModalStack';

export default function PrivateEventCalendarLayoutRoute() {
  return <ModalStack />;
}
